import { ChartDashboardItem } from "../../../components";
import { DashboardService } from "../../../services";
import { DashboardRequest, DailyBookingResponse } from "../../../models";
import { useSelector } from "react-redux";
import { getUserInfo } from "../../../app";
import { ChartSeriesItem } from "@progress/kendo-react-charts";
import { useAsync } from "../../../hooks";

// Example data for the chart
// const series = [
//   { name: "Hush", data: [10, 20, 15], color: "Green" },
//   { name: "UV", data: [5, 0, 10], color :"red" },
//   { name: "Spray", data: [5, 25, 10], color :"blue"}
// ];
// const categories = ["May 18", "May 19", "May 20"];

export function ServiceTypeStackedBarChart() {

  const categories = ["May 18", "May 19", "May 20"];
  const dashboardService = new DashboardService();
  const userId = useSelector(getUserInfo())?.id;

  const request: DashboardRequest = {
    options: {
      userId: userId,
      startDate: new Date("2025-06-01").toISOString().split('T')[0],
      endDate: new Date("2025-06-07").toISOString().split('T')[0],
    },
    name:"DailyBooking",
  }

  const { value, loading, error } = useAsync(() => dashboardService.postAsync<DailyBookingResponse>(request), []);

  return (
    <ChartDashboardItem
      categories={categories}
      type="column"
    >
      {value?.serviceTypeCounts.map((item, index) => (
        <ChartSeriesItem
          key={index}
          type="column"
          name={item.name}
          data={item.data}
          color={item.color}
          stack={true}
        />
      ))}
    </ChartDashboardItem>
  );
}

export default ServiceTypeStackedBarChart;
